module.exports = __webpack_public_path__ + "static/media/corporate.082160e5.svg";